import React, { useState } from "react";
import { useAuth } from "../context/AuthProvider";
import axios from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

const EditProfilePage = () => {
    const { user, setUser } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: user?.name || "",
        email: user?.email || "",
        password: "",
        newPassword: "",
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        try {
            const updateData = {
                name: form.name,
                email: form.email,
            };
            // If user wants to change password
            if (form.newPassword) {
                updateData.password = form.newPassword;
            }
            const res = await axios.put('/users/me', updateData);
            if (res.data.success) {
                setUser(res.data.user); // Update context
                setMessage({ type: "success", text: "Profile updated successfully!" });
                setTimeout(() => navigate("/account"), 1200);
            } else {
                setMessage({ type: "error", text: "Failed to update profile." });
            }
        } catch (err) {
            console.error(err);
            setMessage({ type: "error", text: err.response?.data?.error || "Error updating profile." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex justify-center items-center bg-gray-50 py-12">
            <div className="bg-white rounded-xl shadow-xl p-8 w-full max-w-md">
                <h1 className="text-2xl font-semibold mb-6 text-center">Edit Profile</h1>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block font-medium mb-1">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg"
                            required
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg"
                        />
                    </div>
                    {/* Password update (optional) */}
                    <div>
                        <label className="block font-medium mb-1">New Password</label>
                        <input
                            type="password"
                            name="newPassword"
                            value={form.newPassword}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg"
                            placeholder="Leave empty to keep current password"
                            autoComplete="new-password"
                        />
                    </div>
                    {message && (
                        <div className={`text-sm py-2 text-center ${message.type === "success" ? "text-green-600" : "text-rose-500"}`}>
                            {message.text}
                        </div>
                    )}
                    <button
                        type="submit"
                        className="w-full bg-black text-white py-2 rounded-lg font-medium hover:bg-gray-800 transition"
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save Changes"}
                    </button>
                    <button
                        type="button"
                        className="w-full mt-2 bg-gray-100 text-gray-700 py-2 rounded-lg font-medium hover:bg-gray-200 transition"
                        onClick={() => navigate("/account")}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EditProfilePage;
